import { SoapSetting } from "../models/dictation.interface";

export enum ResourceType {
  SUBJECTIVE = 'Subjective',
  OBJECTIVE = 'Objective',
  ASSESSMENT = 'Assessment',
  PLAN = 'Plan'
}

export enum SubSectionTitle {
  CHIEF_COMPLAINTS = 'Chief Complaints',
  OBSERVATIONS = 'Observations',
  ASSESSMENT = 'Assessment',
  LAB_ORDER = 'Lab Order',
  PLAN = 'Plan',
  PHYSICAL_EXAM = 'Physical Exam',
  "PRESCRIPTION/MEDICATION" = 'Prescription/Medication',
  ALLERGY = 'Allergy',
  FAMILY_HISTORY = 'Family History',
  SOCIAL_HISTORY = 'Social History',
  GENERIC_MEDICATION = "Generic Medication",
  CURRENT_MEDICATION = "Current Medication",
  CLINICAL_IMPRESSION = "Clinical Impression",
  LAB_REPORT = "Lab Report",
  VITAL_SIGNS = 'Vital Signs'
}

export enum SectionType {
  text = "text",
  list = "list",
  dropdown = "dropdown",
  date = "date",
  number = "number",
}

export enum SOAP_AI_Title {
  Symptoms = "Symptoms",
  Condition = "Condition",
  History_Of_Illness = "History_Of_Illness",
  Observations = "Observations",
  Diagnosis = "Diagnosis",
  Physical_Examination = "Physical_Examination",
  Lab_Report = "Lab_Report",
  Clinical_Impression = "Clinical_Impression",
  History_Of_Allergy = "History_Of_Allergy",
  Family_History = "Family_History",
  Social_History = "Social_History",
  Further_Plan = "Further_Plan",
  Lab_Order = "Lab_Order",
  Imaging_Order = "Imaging_Order",
  Recommended_Exercise = "Recommended_Exercise",
  Medication = "Medication",
  Immunization_Recommended = "Immunization_Recommended",
  Nutrition_Recommended = "Nutrition_Recommended",
  Referrals = "Referrals",
  Allergy_Addition = "Allergy_Addition",
  Vitals = "Vitals",
  Generic_Medication = "Generic_Medication",
  Current_Medication = "Current_Medication"
}

export enum TableType {
  vertical = "vertical",
  horizontal = "horizontal"
}

export enum soapTemplateType {
  Classic = 'soap-classic',
  Structured = 'soap-structured',
  Lite = 'soap-lite',
  ISSUE_LIST = 'issues-lite'
}

export const DefaultSoapSettings: SoapSetting = {
  "active": [
    {
      "type": ResourceType.SUBJECTIVE,
      "resources": [
        {
          "id": 1,
          "title": "Chief Complaints",
          "tableType": TableType.horizontal
        },
        {
          "id": 12,
          "title": "Current Medication",
          "tableType": TableType.vertical
        }
      ],
      "color": "#91ce88"
    },
    {
      "type": ResourceType.OBJECTIVE,
      "resources": [
        {
          "id": 4,
          "title": "Observations",
          "tableType": TableType.vertical
        },
        {
          "id": 15,
          "title": "Vital Signs",
          "tableType": TableType.vertical
        },
        {
          "id": 5,
          "title": "Physical Exam",
          "tableType": TableType.vertical
        }
      ],
      "color": "#7ad6e3"
    },
    {
      "type": ResourceType.ASSESSMENT,
      "resources": [
        {
          "id": 9,
          "title": "Assessment",
          "tableType": TableType.horizontal
        },
        {
          "id": 14,
          "title": "Lab Report",
          "tableType": TableType.vertical
        }
      ],
      "color": "#b9a2fa"
    },
    {
      "type": ResourceType.PLAN,
      "resources": [
        {
          "id": 10,
          "title": "Plan",
          "tableType": TableType.horizontal
        },
        {
          "id": 3,
          "title": "Prescription/Medication",
          "tableType": TableType.horizontal,
          "type": ResourceType.OBJECTIVE
        },
        {
          "id": 2,
          "title": "Lab Order",
          "tableType": TableType.horizontal
        }
      ],
      "color": "#fbb955"
    }
  ],
  "pending": [
    {
      "id": 6,
      "title": "Family History",
      "tableType": TableType.horizontal
    },
    {
      "id": 7,
      "title": "Social History",
      "tableType": TableType.vertical
    },
    {
      "id": 8,
      "title": "Allergy",
      "tableType": TableType.horizontal
    },
    {
      "id": 11,
      "title": "Generic Medication",
      "tableType": TableType.vertical
    },
    {
      "id": 13,
      "title": "Clinical Impression",
      "tableType": TableType.vertical
    }
  ]
}

interface VitalRes {
  ele: string;
  error: string;
  status: string;
}

export interface VitalResponse {
  failures: string[],
  successes: VitalRes[]
}
